import React from "react";

export interface MyInfoContextType {
  isKorean: boolean;
}

export const MyInfoContext = React.createContext<MyInfoContextType>(null!);
